import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import imagen from './sobre-nosotros.jpg'
import './App.css';

class SobreNosotros extends Component {
	render() {
		return (
			<Fragment>
				<div className="nav">
					<div className="nav-bar">
						<ul className="nav-list">
							<li><Link to="/">Inicio</Link></li>
							<li><Link to="/quienes-somos">Quienes somos</Link></li>
							<li><Link to="/sobre-nosotros" className="active">Sobre nosotros</Link></li>
						</ul>
					</div>
				</div>
				<div className="main-wrapper">
					<div className="main">
						<div className="static-banner mb-3">
							<img className="img-fluid" src={imagen} alt="sobre nosotros img" />
						</div>
						<div>
							<p>Al igual que un edificio requiere unos cimientos sólidos sobre los que sustentarse, un proyecto empresarial necesita su por qué, cómo, y para qué como base a partir de la cual desarrollar su actividad. Es lo que se conoce como filosofía de empresa, y define su propósito, misión y visión.</p>
							<p>Nuestro propósito es lograr que pague menos por lo mismo, o igual por algo mejor. Actualmente ofrecemos este servicio a responsables de compras, sobre todo del sector de la construcción, pero estamos abiertos a ampliarlo a otras áreas en el futuro.</p>
							<p>Como misión tenemos la mejora continua de nuestro modelo de gestión para obtener siempre la máxima efectividad, eficiencia más eficacia, en el proceso de obtención de resultados, incluso valorando sostenibilidad y respeto al medio ambiente en la toma de decisiones.</p>
							<p>En nuestra visión, aquello que aspiramos a lograr, aparece el concepto de crear valor, pero no el económico, sino el añadido que perciban nuestros clientes y colaboradores como resultado del compromiso y efectividad nuestra gestión. La excelencia en gestión enfocada a la entera satisfacción del cliente es nuestra mayor aspiración.</p>
							<p>Pero por encima de todo están quienes lo hacen posible, las personas que integran nuestro equipo, y cuyo denominador común es la vocación de servicio, que incluye la pasión por nuestro trabajo y la empatía con nuestros clientes, asumiendo sus necesidades como nuestras, y siempre comprometidos en hacer las cosas lo mejor que podamos, sin dejar de mejorar constantemente.</p>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

export default SobreNosotros;


// WEBPACK FOOTER //
// ./src/SobreNosotros.jsx